<script>
    import {
      Card,
      CardBody,
    } from "sveltestrap";

</script>

<Card>
    <CardBody>
        <div class="mb-4 h1 card-title">Data Fields</div>
        <div>
          
          
            <ul>
                <li>
<p class="card-text">"fact": a string feature</p></li>
<li><p class="card-text">"laws_service": a string feature</p></li>
<li><p class="card-text">"laws_service_id": a classification label, with <strike>178</strike> 177 (2022. 11. 15. updated) legal judgment values</p></li>
                
            </ul>


          
        </div>
      </CardBody>
</Card>